// Pie chart width constants
export const PIE_CHART_MIN_WIDTH = 500;
export const PIE_CHART_EXPANDED_WIDTH = 600;

export const month = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const lineColors: MultiLineColors = {
  '765105e1-4a3f-4716-b878-4bbe00de541a': '#50A1DE',
  '7732204d-81d9-476c-b2b0-041b23852309': '#FF0000',
};

export interface MultiLineColors {
  [guid: string]: string;
}

export const multiLineColors: MultiLineColors = {
  '712c3c74-4864-4787-9592-1eecabfbf4cd': '#00060F',
  '944223c8-2853-43fe-bacb-fec02dd99520': '#66D5A7',
  'aa5c11c4-8408-4221-8e8d-af4c7f14e14c': '#FF0000',
  '765105e1-4a3f-4716-b878-4bbe00de541a': '#BDEDD9',
  '7732204d-81d9-476c-b2b0-041b23852309': '#FBC3C3',
};

export const pieColors: MultiLineColors = {
  '59f8d408-c4e8-4e99-b1d3-47656db3edcf': '#C5E0B5',
  '8be8f283-c375-4e0c-9459-42771918aa5d': '#06B050',
  '39a5538e-ab8a-464f-a24d-137f4828661d': '#47D359',
  'd41d76ee-6959-49ff-bab0-2da026c30c00': '#83E28E',
  '2a78ea37-6b98-4a5e-aae1-d31f7ba69c1b': '#FF0000',
};

export const slcpCompliancePieColors: MultiLineColors = {
  '712c3c74-4864-4787-9592-1eecabfbf4cd': '#00060F',
  '944223c8-2853-43fe-bacb-fec02dd99520': '#66D5A7',
  'aa5c11c4-8408-4221-8e8d-af4c7f14e14c': '#FF0000',
};

export const generatorsNotCompliantByContainerPieColors: MultiLineColors = {
  'e1f3f6a1-5d2e-4c4b-9f7a-2b8f3e6d9c4a': '#767d86',
  'a3b2c1d4-e5f6-4789-8a9b-0c1d2e3f4a5b': '#28cb86',
  'f4b8c9d2-3e6f-4a5b-8c7d-1e2f3a4b5c6d': '#03408c',

  'b1c2d3e4-f5a6-4789-9a0b-1c2d3e4f5a6b': '#62a588',
  'c1d2e3f4-a5b6-4789-0a1b-2c3d4e5f6a7b': '#4e5e8a',
  'd1e2f3a4-b5c6-4789-1a2b-3c4d5e6f7a8b': '#32848d',
  'e2f3a4b5-c6d7-4789-2a3b-4c5d6e7f8a9b': '#a2bcc2ff',
};

export const squareIconButtonSx = {
  padding: 0,
  width: '24px',
  height: '22px',
  borderRadius: '4px',
};

export const chartIconButtonSx = {
  width: 36,
  height: 36,
  borderRadius: '4px',
  backgroundColor: '#FFFFFF',
  padding: 0,
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
    color: '#667085',
  },
};

export const contextButtonTheme = {
  symbol: 'menu',
  symbolFill: '#667085',
  symbolStroke: '#667085',
  symbolStrokeWidth: 2,
  symbolSize: 18,
  symbolX: 18,
  symbolY: 18,
  width: 36,
  height: 36,
  theme: {
    fill: '#FFFFFF',
    states: {
      hover: {
        fill: '#F5F5F5',
      },
      select: {
        fill: '#E8E8E8',
      },
    },
  },
};

// Chart height (shared by line charts and pie charts)
export const CHART_HEIGHT = 500;

// Pie Chart shared configuration
export const PIE_CHART_SIZE_DEFAULT = '70%';
export const PIE_CHART_SIZE_SMALL = '95%';

export const pieChartLegendConfig = {
  enabled: true,
  layout: 'vertical' as const,
  align: 'right' as const,
  verticalAlign: 'middle' as const,
  itemMarginTop: 6,
  itemMarginBottom: 6,
  itemStyle: {
    fontSize: '16px',
    fontFamily: 'Arial',
  },
};

export const pieChartResponsiveConfig = {
  rules: [
    {
      condition: { maxWidth: 600 },
      chartOptions: {
        legend: {
          itemStyle: { fontSize: '14px' },
        },
        plotOptions: {
          pie: {
            size: PIE_CHART_SIZE_SMALL,
          },
        },
      },
    },
  ],
};

export const chartLoadingConfig = {
  style: {
    opacity: 0.7,
    top: '0px',
    left: '0px',
  },
  labelStyle: {
    fontSize: '24px',
  },
};

export const chartTitleStyle = {
  fontFamily: 'Arial',
  fontSize: '21px',
  fontWeight: '600',
};

export const pieDataLabelsStyle = {
  fontSize: '16px',
  fontFamily: 'Arial',
  fontWeight: 'normal',
};

// Legend label formatters
export const formatLegendValue = (value: number | string | undefined) =>
  `<span style="font-size: calc(1em + 1px);">${value}</span>`;

export const formatLegendLabel = (
  name: string,
  value: number | string | undefined,
  lineBreak = false,
) => {
  const formattedValue = formatLegendValue(value);
  return lineBreak ? `${name}:<br/>${formattedValue}` : `${name}: ${formattedValue}`;
};

